import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { DeleteSurveyDialog } from 'modules/engagement_surveys/components/DeleteSurveyDialog'

type Data = {
  surveyId: string
}

export const DeleteSurveyActivity: ActivityComponent<Data> = ({ surveyId }) => {
  const { open, closeActivity } = useActivity()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  if (!open) return null

  return (
    <DeleteSurveyDialog
      surveyId={surveyId}
      onSuccess={() => {
        closeActivity()
        navigate(navigation.engagement.smart_surveys.fullPath())
      }}
      onCancel={closeActivity}
    />
  )
}
